// extracted by mini-css-extract-plugin
export default {"gifbox":"index_gifbox_I0i9r","gifmark":"index_gifmark_wbvEV","gifmarkbox":"index_gifmarkbox_wVMh-","gifMask":"index_gifMask_mjAiS"};